@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(823_509_969)
public val Res.string.location_notice_title: StringResource by lazy {
      StringResource("string:location_notice_title", "location_notice_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 180717, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 256477, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164452, 65),
      ))
    }

@delegate:ResourceContentHash(-544_890_134)
public val Res.string.map_attribution: StringResource by lazy {
      StringResource("string:map_attribution", "map_attribution", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 180795, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 256607, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164518, 63),
      ))
    }

@delegate:ResourceContentHash(971_814_289)
public val Res.string.market_poland: StringResource by lazy {
      StringResource("string:market_poland", "market_poland", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 180851, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 256675, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164582, 29),
      ))
    }

@delegate:ResourceContentHash(1_917_379_008)
public val Res.string.marketplace: StringResource by lazy {
      StringResource("string:marketplace", "marketplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 180881, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 256713, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164612, 35),
      ))
    }

@delegate:ResourceContentHash(1_321_993_893)
public val Res.string.menu_about: StringResource by lazy {
      StringResource("string:menu_about", "menu_about", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 180921, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 256761, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164648, 38),
      ))
    }

@delegate:ResourceContentHash(-1_086_099_711)
public val Res.string.menu_back: StringResource by lazy {
      StringResource("string:menu_back", "menu_back", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 180968, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 256800, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164687, 25),
      ))
    }

@delegate:ResourceContentHash(461_734_312)
public val Res.string.menu_close_window: StringResource by lazy {
      StringResource("string:menu_close_window", "menu_close_window", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 180994, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 256834, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164713, 41),
      ))
    }

@delegate:ResourceContentHash(760_381_589)
public val Res.string.menu_copy: StringResource by lazy {
      StringResource("string:menu_copy", "menu_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181036, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 256896, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164755, 25),
      ))
    }

@delegate:ResourceContentHash(1_351_664_559)
public val Res.string.menu_cut: StringResource by lazy {
      StringResource("string:menu_cut", "menu_cut", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181062, 24),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 256938, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164781, 20),
      ))
    }

@delegate:ResourceContentHash(-539_270_258)
public val Res.string.menu_edit: StringResource by lazy {
      StringResource("string:menu_edit", "menu_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181087, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 256979, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164802, 25),
      ))
    }

@delegate:ResourceContentHash(-545_372_018)
public val Res.string.menu_file: StringResource by lazy {
      StringResource("string:menu_file", "menu_file", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181113, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257029, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164828, 25),
      ))
    }

@delegate:ResourceContentHash(1_624_911_059)
public val Res.string.menu_help: StringResource by lazy {
      StringResource("string:menu_help", "menu_help", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181184, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257116, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164899, 25),
      ))
    }

@delegate:ResourceContentHash(-147_993_374)
public val Res.string.menu_help_centre: StringResource by lazy {
      StringResource("string:menu_help_centre", "menu_help_centre", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181139, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257059, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164854, 44),
      ))
    }

@delegate:ResourceContentHash(-1_251_786_996)
public val Res.string.menu_minimize: StringResource by lazy {
      StringResource("string:menu_minimize", "menu_minimize", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181210, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257154, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164925, 33),
      ))
    }

@delegate:ResourceContentHash(-1_504_885_048)
public val Res.string.menu_notifications: StringResource by lazy {
      StringResource("string:menu_notifications", "menu_notifications", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181248, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257200, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164959, 46),
      ))
    }

@delegate:ResourceContentHash(-1_102_699_767)
public val Res.string.menu_paste: StringResource by lazy {
      StringResource("string:menu_paste", "menu_paste", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181295, 26),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257255, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165006, 26),
      ))
    }

@delegate:ResourceContentHash(190_090_635)
public val Res.string.menu_profile: StringResource by lazy {
      StringResource("string:menu_profile", "menu_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181322, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257298, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165033, 32),
      ))
    }

@delegate:ResourceContentHash(-145_137_917)
public val Res.string.menu_redo: StringResource by lazy {
      StringResource("string:menu_redo", "menu_redo", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181351, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257339, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165066, 25),
      ))
    }

@delegate:ResourceContentHash(-320_591_870)
public val Res.string.menu_select_all: StringResource by lazy {
      StringResource("string:menu_select_all", "menu_select_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181381, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257381, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165092, 39),
      ))
    }

@delegate:ResourceContentHash(-1_296_501_211)
public val Res.string.menu_switch_workplace: StringResource by lazy {
      StringResource("string:menu_switch_workplace", "menu_switch_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181429, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257433, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165132, 57),
      ))
    }

@delegate:ResourceContentHash(-1_739_109_132)
public val Res.string.menu_this_month: StringResource by lazy {
      StringResource("string:menu_this_month", "menu_this_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181479, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257503, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165190, 39),
      ))
    }

@delegate:ResourceContentHash(1_422_880_375)
public val Res.string.menu_undo: StringResource by lazy {
      StringResource("string:menu_undo", "menu_undo", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181527, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257567, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165230, 25),
      ))
    }

@delegate:ResourceContentHash(-1_771_468_612)
public val Res.string.menu_view: StringResource by lazy {
      StringResource("string:menu_view", "menu_view", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181553, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257609, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165256, 25),
      ))
    }

@delegate:ResourceContentHash(-1_209_879_206)
public val Res.string.menu_window: StringResource by lazy {
      StringResource("string:menu_window", "menu_window", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181579, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257643, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165282, 27),
      ))
    }

@delegate:ResourceContentHash(1_063_749_081)
public val Res.string.menu_workplace: StringResource by lazy {
      StringResource("string:menu_workplace", "menu_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181607, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257679, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165310, 34),
      ))
    }

@delegate:ResourceContentHash(1_519_040_107)
public val Res.string.menu_zoom: StringResource by lazy {
      StringResource("string:menu_zoom", "menu_zoom", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181638, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257718, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165345, 25),
      ))
    }

@delegate:ResourceContentHash(-933_768_244)
public val Res.string.missing_pay_hint: StringResource by lazy {
      StringResource("string:missing_pay_hint", "missing_pay_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181668, 144),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257760, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165371, 112),
      ))
    }

@delegate:ResourceContentHash(-183_721_104)
public val Res.string.missing_pay_person: StringResource by lazy {
      StringResource("string:missing_pay_person", "missing_pay_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181813, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 257981, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165484, 74),
      ))
    }

@delegate:ResourceContentHash(-1_142_069_701)
public val Res.string.missing_pay_set: StringResource by lazy {
      StringResource("string:missing_pay_set", "missing_pay_set", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181892, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258072, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165559, 35),
      ))
    }

@delegate:ResourceContentHash(-947_214_709)
public val Res.string.missing_pay_unpaid_me: StringResource by lazy {
      StringResource("string:missing_pay_unpaid_me", "missing_pay_unpaid_me", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 181944, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258140, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165595, 77),
      ))
    }

@delegate:ResourceContentHash(2_106_871_924)
public val Res.string.missing_pay_unpaid_other: StringResource by lazy {
      StringResource("string:missing_pay_unpaid_other", "missing_pay_unpaid_other", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182022, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258230, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165673, 56),
      ))
    }

@delegate:ResourceContentHash(1_136_127_194)
public val Res.string.money_per_hour: StringResource by lazy {
      StringResource("string:money_per_hour", "money_per_hour", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182091, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258307, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165730, 30),
      ))
    }

@delegate:ResourceContentHash(-1_386_491_672)
public val Res.string.month_1: StringResource by lazy {
      StringResource("string:month_1", "month_1", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182213, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258461, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165848, 27),
      ))
    }

@delegate:ResourceContentHash(366_218_988)
public val Res.string.month_10: StringResource by lazy {
      StringResource("string:month_10", "month_10", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182122, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258346, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165761, 28),
      ))
    }

@delegate:ResourceContentHash(393_569_742)
public val Res.string.month_11: StringResource by lazy {
      StringResource("string:month_11", "month_11", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182155, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258383, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165790, 28),
      ))
    }

@delegate:ResourceContentHash(1_072_686_351)
public val Res.string.month_12: StringResource by lazy {
      StringResource("string:month_12", "month_12", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182184, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258424, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165819, 28),
      ))
    }

@delegate:ResourceContentHash(1_194_084_263)
public val Res.string.month_2: StringResource by lazy {
      StringResource("string:month_2", "month_2", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182241, 23),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258493, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165876, 27),
      ))
    }

@delegate:ResourceContentHash(490_970_704)
public val Res.string.month_3: StringResource by lazy {
      StringResource("string:month_3", "month_3", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182265, 23),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258525, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165904, 23),
      ))
    }

@delegate:ResourceContentHash(919_169_583)
public val Res.string.month_4: StringResource by lazy {
      StringResource("string:month_4", "month_4", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182289, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258565, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165928, 23),
      ))
    }

@delegate:ResourceContentHash(64_825_326)
public val Res.string.month_5: StringResource by lazy {
      StringResource("string:month_5", "month_5", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182317, 19),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258601, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165952, 19),
      ))
    }

@delegate:ResourceContentHash(2_093_159_021)
public val Res.string.month_6: StringResource by lazy {
      StringResource("string:month_6", "month_6", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182337, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258637, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165972, 23),
      ))
    }

@delegate:ResourceContentHash(589_916_649)
public val Res.string.month_7: StringResource by lazy {
      StringResource("string:month_7", "month_7", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182365, 23),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258673, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165996, 23),
      ))
    }

@delegate:ResourceContentHash(-672_315_199)
public val Res.string.month_8: StringResource by lazy {
      StringResource("string:month_8", "month_8", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182389, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258705, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166020, 23),
      ))
    }

@delegate:ResourceContentHash(-473_934_406)
public val Res.string.month_9: StringResource by lazy {
      StringResource("string:month_9", "month_9", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182417, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258741, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166044, 27),
      ))
    }

@delegate:ResourceContentHash(-253_628_623)
public val Res.string.month_calendar_label: StringResource by lazy {
      StringResource("string:month_calendar_label", "month_calendar_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182445, 188),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 258781, 252),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166072, 172),
      ))
    }

@delegate:ResourceContentHash(1_845_206_807)
public val Res.string.month_gen_1: StringResource by lazy {
      StringResource("string:month_gen_1", "month_gen_1", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182741, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259153, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166344, 31),
      ))
    }

@delegate:ResourceContentHash(-105_979_886)
public val Res.string.month_gen_10: StringResource by lazy {
      StringResource("string:month_gen_10", "month_gen_10", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182634, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259034, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166245, 32),
      ))
    }

@delegate:ResourceContentHash(1_772_136_039)
public val Res.string.month_gen_11: StringResource by lazy {
      StringResource("string:month_gen_11", "month_gen_11", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182675, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259071, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166278, 32),
      ))
    }

@delegate:ResourceContentHash(-1_950_253_570)
public val Res.string.month_gen_12: StringResource by lazy {
      StringResource("string:month_gen_12", "month_gen_12", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182708, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259116, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166311, 32),
      ))
    }

@delegate:ResourceContentHash(-906_940_363)
public val Res.string.month_gen_2: StringResource by lazy {
      StringResource("string:month_gen_2", "month_gen_2", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182773, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259189, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166376, 31),
      ))
    }

@delegate:ResourceContentHash(-1_703_487_631)
public val Res.string.month_gen_3: StringResource by lazy {
      StringResource("string:month_gen_3", "month_gen_3", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182801, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259225, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166408, 27),
      ))
    }

@delegate:ResourceContentHash(1_840_679_798)
public val Res.string.month_gen_4: StringResource by lazy {
      StringResource("string:month_gen_4", "month_gen_4", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182829, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259265, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166436, 27),
      ))
    }

@delegate:ResourceContentHash(-1_800_653_432)
public val Res.string.month_gen_5: StringResource by lazy {
      StringResource("string:month_gen_5", "month_gen_5", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182861, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259301, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166464, 23),
      ))
    }

@delegate:ResourceContentHash(-1_607_791_494)
public val Res.string.month_gen_6: StringResource by lazy {
      StringResource("string:month_gen_6", "month_gen_6", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182889, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259337, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166488, 27),
      ))
    }

@delegate:ResourceContentHash(-1_905_888_959)
public val Res.string.month_gen_7: StringResource by lazy {
      StringResource("string:month_gen_7", "month_gen_7", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182921, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259373, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166516, 27),
      ))
    }

@delegate:ResourceContentHash(198_329_343)
public val Res.string.month_gen_8: StringResource by lazy {
      StringResource("string:month_gen_8", "month_gen_8", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182949, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259409, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166544, 27),
      ))
    }

@delegate:ResourceContentHash(-2_083_753_142)
public val Res.string.month_gen_9: StringResource by lazy {
      StringResource("string:month_gen_9", "month_gen_9", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 182981, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259445, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166572, 31),
      ))
    }

@delegate:ResourceContentHash(-1_459_676_352)
public val Res.string.month_in_1: StringResource by lazy {
      StringResource("string:month_in_1", "month_in_1", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183133, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259625, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166712, 34),
      ))
    }

@delegate:ResourceContentHash(-1_129_499_951)
public val Res.string.month_in_10: StringResource by lazy {
      StringResource("string:month_in_10", "month_in_10", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183013, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259485, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166604, 35),
      ))
    }

@delegate:ResourceContentHash(-1_750_880_264)
public val Res.string.month_in_11: StringResource by lazy {
      StringResource("string:month_in_11", "month_in_11", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183057, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259529, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166640, 35),
      ))
    }

@delegate:ResourceContentHash(-623_199_296)
public val Res.string.month_in_12: StringResource by lazy {
      StringResource("string:month_in_12", "month_in_12", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183097, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259581, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166676, 35),
      ))
    }

@delegate:ResourceContentHash(1_410_471_988)
public val Res.string.month_in_2: StringResource by lazy {
      StringResource("string:month_in_2", "month_in_2", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183168, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259664, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166747, 34),
      ))
    }

@delegate:ResourceContentHash(1_144_701_032)
public val Res.string.month_in_3: StringResource by lazy {
      StringResource("string:month_in_3", "month_in_3", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183199, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259707, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166782, 30),
      ))
    }

@delegate:ResourceContentHash(-2_118_086_713)
public val Res.string.month_in_4: StringResource by lazy {
      StringResource("string:month_in_4", "month_in_4", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183230, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259750, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166813, 30),
      ))
    }

@delegate:ResourceContentHash(2_040_135_236)
public val Res.string.month_in_5: StringResource by lazy {
      StringResource("string:month_in_5", "month_in_5", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183265, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259793, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166844, 26),
      ))
    }

@delegate:ResourceContentHash(5_100_921)
public val Res.string.month_in_6: StringResource by lazy {
      StringResource("string:month_in_6", "month_in_6", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183296, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259836, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166871, 30),
      ))
    }

@delegate:ResourceContentHash(130_488_758)
public val Res.string.month_in_7: StringResource by lazy {
      StringResource("string:month_in_7", "month_in_7", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183331, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259879, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166902, 30),
      ))
    }

@delegate:ResourceContentHash(-1_502_984_731)
public val Res.string.month_in_8: StringResource by lazy {
      StringResource("string:month_in_8", "month_in_8", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183362, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259918, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166933, 30),
      ))
    }

@delegate:ResourceContentHash(-462_944_707)
public val Res.string.month_in_9: StringResource by lazy {
      StringResource("string:month_in_9", "month_in_9", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183397, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 259961, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166964, 34),
      ))
    }

@delegate:ResourceContentHash(867_767_863)
public val Res.string.month_sentence_lowercase: StringResource by lazy {
      StringResource("string:month_sentence_lowercase", "month_sentence_lowercase", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183436, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260004, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166999, 40),
      ))
    }

@delegate:ResourceContentHash(273_788_342)
public val Res.string.monthly_result_actual: StringResource by lazy {
      StringResource("string:monthly_result_actual", "monthly_result_actual", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183477, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260045, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167040, 37),
      ))
    }

@delegate:ResourceContentHash(-1_093_622_858)
public val Res.string.monthly_result_commission: StringResource by lazy {
      StringResource("string:monthly_result_commission", "monthly_result_commission", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183519, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260087, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167078, 57),
      ))
    }

@delegate:ResourceContentHash(-1_597_638_897)
public val Res.string.monthly_result_costs: StringResource by lazy {
      StringResource("string:monthly_result_costs", "monthly_result_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183565, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260141, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167136, 36),
      ))
    }

@delegate:ResourceContentHash(773_750_613)
public val Res.string.monthly_result_coverage: StringResource by lazy {
      StringResource("string:monthly_result_coverage", "monthly_result_coverage", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183602, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260190, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167173, 91),
      ))
    }

@delegate:ResourceContentHash(-12_382_491)
public val Res.string.monthly_result_fixed_costs: StringResource by lazy {
      StringResource("string:monthly_result_fixed_costs", "monthly_result_fixed_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183710, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260346, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167265, 50),
      ))
    }

@delegate:ResourceContentHash(-783_010_447)
public val Res.string.monthly_result_fixed_revenue: StringResource by lazy {
      StringResource("string:monthly_result_fixed_revenue", "monthly_result_fixed_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183765, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260425, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167316, 56),
      ))
    }

@delegate:ResourceContentHash(644_391_538)
public val Res.string.monthly_result_forecast: StringResource by lazy {
      StringResource("string:monthly_result_forecast", "monthly_result_forecast", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183826, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260506, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167373, 79),
      ))
    }

@delegate:ResourceContentHash(689_033_853)
public val Res.string.monthly_result_labour: StringResource by lazy {
      StringResource("string:monthly_result_labour", "monthly_result_labour", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183902, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260602, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167453, 61),
      ))
    }

@delegate:ResourceContentHash(903_205_032)
public val Res.string.monthly_result_margin: StringResource by lazy {
      StringResource("string:monthly_result_margin", "monthly_result_margin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 183964, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260716, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167515, 37),
      ))
    }

@delegate:ResourceContentHash(-146_182_785)
public val Res.string.monthly_result_net_sales: StringResource by lazy {
      StringResource("string:monthly_result_net_sales", "monthly_result_net_sales", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 184085, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260857, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167620, 68),
      ))
    }

@delegate:ResourceContentHash(660_788_914)
public val Res.string.monthly_result_net_sales_total: StringResource by lazy {
      StringResource("string:monthly_result_net_sales_total", "monthly_result_net_sales_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 184002, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260762, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167553, 66),
      ))
    }

@delegate:ResourceContentHash(314_863_714)
public val Res.string.monthly_result_no_margin: StringResource by lazy {
      StringResource("string:monthly_result_no_margin", "monthly_result_no_margin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 184166, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 260958, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167689, 36),
      ))
    }

@delegate:ResourceContentHash(1_162_973_022)
public val Res.string.monthly_result_note: StringResource by lazy {
      StringResource("string:monthly_result_note", "monthly_result_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 184215, 507),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 261007, 803),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167726, 503),
      ))
    }

@delegate:ResourceContentHash(-1_634_148_975)
public val Res.string.monthly_result_one_off: StringResource by lazy {
      StringResource("string:monthly_result_one_off", "monthly_result_one_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 184790, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 261886, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168289, 50),
      ))
    }

@delegate:ResourceContentHash(56_447_488)
public val Res.string.monthly_result_one_off_revenue: StringResource by lazy {
      StringResource("string:monthly_result_one_off_revenue", "monthly_result_one_off_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 184723, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 261811, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168230, 58),
      ))
    }

@delegate:ResourceContentHash(-1_365_715_965)
public val Res.string.monthly_result_own_sales: StringResource by lazy {
      StringResource("string:monthly_result_own_sales", "monthly_result_own_sales", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 184845, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 261953, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168340, 44),
      ))
    }

@delegate:ResourceContentHash(-1_095_503_361)
public val Res.string.monthly_result_recurring_revenue: StringResource by lazy {
      StringResource("string:monthly_result_recurring_revenue", "monthly_result_recurring_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 184898, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262022, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168385, 64),
      ))
    }

@delegate:ResourceContentHash(-1_223_248_724)
public val Res.string.monthly_result_result: StringResource by lazy {
      StringResource("string:monthly_result_result", "monthly_result_result", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 184967, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262107, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168450, 37),
      ))
    }

@delegate:ResourceContentHash(-1_568_102_855)
public val Res.string.monthly_result_revenue: StringResource by lazy {
      StringResource("string:monthly_result_revenue", "monthly_result_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185005, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262161, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168488, 42),
      ))
    }

@delegate:ResourceContentHash(524_170_320)
public val Res.string.monthly_result_sales_income_mixed: StringResource by lazy {
      StringResource("string:monthly_result_sales_income_mixed", "monthly_result_sales_income_mixed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185048, 93),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262208, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168531, 93),
      ))
    }

@delegate:ResourceContentHash(-1_536_945_261)
public val Res.string.monthly_result_shared_costs: StringResource by lazy {
      StringResource("string:monthly_result_shared_costs", "monthly_result_shared_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185142, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262334, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168625, 63),
      ))
    }

@delegate:ResourceContentHash(-2_122_625_192)
public val Res.string.monthly_result_title: StringResource by lazy {
      StringResource("string:monthly_result_title", "monthly_result_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185206, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262434, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168689, 48),
      ))
    }

@delegate:ResourceContentHash(1_676_447_834)
public val Res.string.more_add_workplace: StringResource by lazy {
      StringResource("string:more_add_workplace", "more_add_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185255, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262507, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168738, 46),
      ))
    }

@delegate:ResourceContentHash(190_090_635)
public val Res.string.more_profile: StringResource by lazy {
      StringResource("string:more_profile", "more_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185368, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262652, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168863, 32),
      ))
    }

@delegate:ResourceContentHash(590_313_229)
public val Res.string.more_profile_hint: StringResource by lazy {
      StringResource("string:more_profile_hint", "more_profile_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185298, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262570, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168785, 77),
      ))
    }

@delegate:ResourceContentHash(-269_570_206)
public val Res.string.more_requests_pending: StringResource by lazy {
      StringResource("string:more_requests_pending", "more_requests_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185397, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262693, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168896, 69),
      ))
    }

@delegate:ResourceContentHash(-1_964_951_782)
public val Res.string.more_section_account: StringResource by lazy {
      StringResource("string:more_section_account", "more_section_account", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185459, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262779, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168966, 40),
      ))
    }

@delegate:ResourceContentHash(-1_763_527_775)
public val Res.string.more_section_work: StringResource by lazy {
      StringResource("string:more_section_work", "more_section_work", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185535, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262895, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169050, 33),
      ))
    }

@delegate:ResourceContentHash(1_063_749_081)
public val Res.string.more_section_workplace: StringResource by lazy {
      StringResource("string:more_section_workplace", "more_section_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185496, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262848, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169007, 42),
      ))
    }

@delegate:ResourceContentHash(1_609_772_454)
public val Res.string.more_switch_workplace: StringResource by lazy {
      StringResource("string:more_switch_workplace", "more_switch_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 185569, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 262937, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169084, 53),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString22Resources(map: MutableMap<String, StringResource>) {
  map.put("location_notice_title", Res.string.location_notice_title)
  map.put("map_attribution", Res.string.map_attribution)
  map.put("market_poland", Res.string.market_poland)
  map.put("marketplace", Res.string.marketplace)
  map.put("menu_about", Res.string.menu_about)
  map.put("menu_back", Res.string.menu_back)
  map.put("menu_close_window", Res.string.menu_close_window)
  map.put("menu_copy", Res.string.menu_copy)
  map.put("menu_cut", Res.string.menu_cut)
  map.put("menu_edit", Res.string.menu_edit)
  map.put("menu_file", Res.string.menu_file)
  map.put("menu_help", Res.string.menu_help)
  map.put("menu_help_centre", Res.string.menu_help_centre)
  map.put("menu_minimize", Res.string.menu_minimize)
  map.put("menu_notifications", Res.string.menu_notifications)
  map.put("menu_paste", Res.string.menu_paste)
  map.put("menu_profile", Res.string.menu_profile)
  map.put("menu_redo", Res.string.menu_redo)
  map.put("menu_select_all", Res.string.menu_select_all)
  map.put("menu_switch_workplace", Res.string.menu_switch_workplace)
  map.put("menu_this_month", Res.string.menu_this_month)
  map.put("menu_undo", Res.string.menu_undo)
  map.put("menu_view", Res.string.menu_view)
  map.put("menu_window", Res.string.menu_window)
  map.put("menu_workplace", Res.string.menu_workplace)
  map.put("menu_zoom", Res.string.menu_zoom)
  map.put("missing_pay_hint", Res.string.missing_pay_hint)
  map.put("missing_pay_person", Res.string.missing_pay_person)
  map.put("missing_pay_set", Res.string.missing_pay_set)
  map.put("missing_pay_unpaid_me", Res.string.missing_pay_unpaid_me)
  map.put("missing_pay_unpaid_other", Res.string.missing_pay_unpaid_other)
  map.put("money_per_hour", Res.string.money_per_hour)
  map.put("month_1", Res.string.month_1)
  map.put("month_10", Res.string.month_10)
  map.put("month_11", Res.string.month_11)
  map.put("month_12", Res.string.month_12)
  map.put("month_2", Res.string.month_2)
  map.put("month_3", Res.string.month_3)
  map.put("month_4", Res.string.month_4)
  map.put("month_5", Res.string.month_5)
  map.put("month_6", Res.string.month_6)
  map.put("month_7", Res.string.month_7)
  map.put("month_8", Res.string.month_8)
  map.put("month_9", Res.string.month_9)
  map.put("month_calendar_label", Res.string.month_calendar_label)
  map.put("month_gen_1", Res.string.month_gen_1)
  map.put("month_gen_10", Res.string.month_gen_10)
  map.put("month_gen_11", Res.string.month_gen_11)
  map.put("month_gen_12", Res.string.month_gen_12)
  map.put("month_gen_2", Res.string.month_gen_2)
  map.put("month_gen_3", Res.string.month_gen_3)
  map.put("month_gen_4", Res.string.month_gen_4)
  map.put("month_gen_5", Res.string.month_gen_5)
  map.put("month_gen_6", Res.string.month_gen_6)
  map.put("month_gen_7", Res.string.month_gen_7)
  map.put("month_gen_8", Res.string.month_gen_8)
  map.put("month_gen_9", Res.string.month_gen_9)
  map.put("month_in_1", Res.string.month_in_1)
  map.put("month_in_10", Res.string.month_in_10)
  map.put("month_in_11", Res.string.month_in_11)
  map.put("month_in_12", Res.string.month_in_12)
  map.put("month_in_2", Res.string.month_in_2)
  map.put("month_in_3", Res.string.month_in_3)
  map.put("month_in_4", Res.string.month_in_4)
  map.put("month_in_5", Res.string.month_in_5)
  map.put("month_in_6", Res.string.month_in_6)
  map.put("month_in_7", Res.string.month_in_7)
  map.put("month_in_8", Res.string.month_in_8)
  map.put("month_in_9", Res.string.month_in_9)
  map.put("month_sentence_lowercase", Res.string.month_sentence_lowercase)
  map.put("monthly_result_actual", Res.string.monthly_result_actual)
  map.put("monthly_result_commission", Res.string.monthly_result_commission)
  map.put("monthly_result_costs", Res.string.monthly_result_costs)
  map.put("monthly_result_coverage", Res.string.monthly_result_coverage)
  map.put("monthly_result_fixed_costs", Res.string.monthly_result_fixed_costs)
  map.put("monthly_result_fixed_revenue", Res.string.monthly_result_fixed_revenue)
  map.put("monthly_result_forecast", Res.string.monthly_result_forecast)
  map.put("monthly_result_labour", Res.string.monthly_result_labour)
  map.put("monthly_result_margin", Res.string.monthly_result_margin)
  map.put("monthly_result_net_sales", Res.string.monthly_result_net_sales)
  map.put("monthly_result_net_sales_total", Res.string.monthly_result_net_sales_total)
  map.put("monthly_result_no_margin", Res.string.monthly_result_no_margin)
  map.put("monthly_result_note", Res.string.monthly_result_note)
  map.put("monthly_result_one_off", Res.string.monthly_result_one_off)
  map.put("monthly_result_one_off_revenue", Res.string.monthly_result_one_off_revenue)
  map.put("monthly_result_own_sales", Res.string.monthly_result_own_sales)
  map.put("monthly_result_recurring_revenue", Res.string.monthly_result_recurring_revenue)
  map.put("monthly_result_result", Res.string.monthly_result_result)
  map.put("monthly_result_revenue", Res.string.monthly_result_revenue)
  map.put("monthly_result_sales_income_mixed", Res.string.monthly_result_sales_income_mixed)
  map.put("monthly_result_shared_costs", Res.string.monthly_result_shared_costs)
  map.put("monthly_result_title", Res.string.monthly_result_title)
  map.put("more_add_workplace", Res.string.more_add_workplace)
  map.put("more_profile", Res.string.more_profile)
  map.put("more_profile_hint", Res.string.more_profile_hint)
  map.put("more_requests_pending", Res.string.more_requests_pending)
  map.put("more_section_account", Res.string.more_section_account)
  map.put("more_section_work", Res.string.more_section_work)
  map.put("more_section_workplace", Res.string.more_section_workplace)
  map.put("more_switch_workplace", Res.string.more_switch_workplace)
}
